import { FC } from 'react';
import { MilieugegevensFlow } from '../milieugegevens-flow';
import { Lozingen } from './lozingen';
import { LozingsvormV1 } from './lozingsvorm-v1';
import { Metingen } from './metingen';
import { Zuiveringswijze } from './zuiveringsplicht';

export const GrondteeltMilieugegevensV1: FC = () => (
  <MilieugegevensFlow
    teeltwijze={0}
    renderZuiveringswijze={() => <Zuiveringswijze />}
    LozingsvormComponent={LozingsvormV1}
    LozingenComponent={Lozingen}
    MetingenComponent={Metingen}
    showFosforStikstof
  />
);
